export enum OffsetCategory {
    pri = "PropertyTax",
    ipp = "PersonalIncomeTax"
}
